var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.148 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.147 6.225 6.86 1.516a.886.886 0 0 0 0-1.257.9.9 0 0 0-1.261 0L.26 5.595a.89.89 0 0 0-.026 1.227l5.362 5.373a.89.89 0 1 0 1.258-1.257z"
  })));
};
export default SvgCaret;